<template>
  <div class="formula-mix-raw">
    <!-- 日粮部分 -->
    <div class="table-section ration-section">
      <div class="section-header">
        <span class="section-title">日粮</span>
        <span class="section-ratio">比例：{{ rationPercentage }}%</span>
      </div>
      <resize-table
        :scroll="{ x: 800, y: rationTableHeight }"
        bordered
        :columns="rationColumns"
        :loading="rawListLoading"
        :data-source="rationList"
        :row-key="record => record.rawId"
        :pagination="false"
        :rowClassName="rowClassname"
      >
        <span slot="customTitleRation"><a-icon @click="fixedColRation" type="pushpin" :theme="filledRation ? 'filled' : 'outlined'" /> 原料名称</span>
        <template slot="rawName" slot-scope="text,record">
          {{ overseasFlag == '1' ? (record.aliasName || text) : text }}
        </template>
        <span slot="minValue" slot-scope="text">
          <span>{{ text || text === 0 ? Number(text).toFixed(4) : '' }}</span>
        </span>
        <span slot="maxValue" slot-scope="text">
          <span>{{ text || text === 0 ? Number(text).toFixed(4) : '' }}</span>
        </span>
        <span slot="taskUasgePer" slot-scope="text">
          <span>{{ text || text === 0 ? text.toFixed(4) : '' }}</span>
        </span>
        <span slot="maxApply" slot-scope="text">
          <span>{{ text || text === 0 ? text.toFixed(3) : '' }}</span>
        </span>
        <span slot="minApply" slot-scope="text">
          <span>{{ text || text === 0 ? text.toFixed(3) : '' }}</span>
        </span>
        <span slot="cost" slot-scope="text">
          <span>{{ text ? text.toFixed(3) : '' }}</span>
        </span>
      </resize-table>
    </div>

    <!-- 补充料部分 -->
    <div class="table-section">
      <div class="section-header">
        <span class="section-title">补充料</span>
        <span class="section-ratio">比例：{{ supplementPercentage }}%</span>
        <span class="section-constraint">约束：按日粮约束</span>
        <a-checkbox class="diff-checkbox" :checked="showDiffOnly" @change="onDiffOnlyCheckboxChange">产品对比差异项</a-checkbox>
      </div>
      <resize-table
        :scroll="{ x: 900, y: supplementTableHeight }"
        bordered
        :columns="supplementColumns"
        :loading="supplementListLoading"
        :data-source="supplementList"
        :row-key="record => record.rawId"
        :pagination="false"
        :rowClassName="rowClassname"
      >
        <span slot="customTitleSupplement"><a-icon @click="fixedColSupplement" type="pushpin" :theme="filledSupplement ? 'filled' : 'outlined'" /> 原料名称</span>
        <template slot="rawName" slot-scope="text,record">
          {{ overseasFlag == '1' ? (record.aliasName || text) : text }}
        </template>
        <template v-for="col in ['minValue', 'maxValue']" slot-scope="text, record" :slot="col">
          <span :key="col + '-text'" v-if="record.isRawDelete == 1 || (record.isExtraProRaw == 1 && record.isDeleted == 1)">
            {{ text ? Number(text).toFixed(4) : '' }}
          </span>
          <cell-editor :key="col + '-editor'" v-else :item="record" :len="4" :name="col" @blur="target => itemUpdate(target)" :text="text" :actions="update" />
        </template>
        <span slot="mixPercentage" slot-scope="text">
          <span>{{ text || text === 0 ? text.toFixed(4) : '' }}</span>
        </span>
        <span slot="taskUasgePer" slot-scope="text">
          <span>{{ text || text === 0 ? text.toFixed(4) : '' }}</span>
        </span>
        <span slot="productRawPercentage" slot-scope="text">
          <span>{{ (text !== null && text !== undefined && text !== '' && text != 0) ? Number(text).toFixed(4) : '' }}</span>
        </span>
        <span slot="uasge" slot-scope="text">
          <span>{{ text || text === 0 ? text.toFixed(4) : '' }}</span>
        </span>
        <span slot="supplementPercentage" slot-scope="text">
          <span>{{ text || text === 0 ? text.toFixed(3) : '' }}</span>
        </span>
        <span slot="maxLimitValue" slot-scope="text">
          <span>{{ text || text === 0 ? text.toFixed(3) : '' }}</span>
        </span>
        <span slot="minLimitValue" slot-scope="text">
          <span>{{ text || text === 0 ? text.toFixed(3) : '' }}</span>
        </span>
      </resize-table>
    </div>
  </div>
</template>

<script>
import CellEditor from '../editor/CellEditor.vue'
import { formulaMixins } from '../unitls'
import formulaMixRawColumns from './formulaMixRawColumns'
export default {
  components: { CellEditor },
  mixins: [formulaMixins],
  props: {
    showDiffOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      formulaMixRawColumns,
      rationList: [],
      supplementList: [],
      rawListLoading: false,
      supplementListLoading: false,
      filledRation: true,
      filledSupplement: true,
      cacheRationData: [],
      cacheSupplementData: [],
      rationPercentage: 0,
      supplementPercentage: 0,
      filterRawType: 0,
    }
  },
  computed: {
    rationTableHeight() {
      const rows = this.rationList.length || 1
      return Math.min(rows * 40, (this.height || 600) * 0.4)
    },
    supplementTableHeight() {
      const containerHeight = this.height || 600
      return containerHeight - this.rationTableHeight - 90
    },
    rationColumns() {
      let columns = [...this.formulaMixRawColumns.ration]
      if (this.filledRation) {
        columns[0].fixed = 'left'
      } else {
        delete columns[0].fixed
      }
      return columns
    },
    supplementColumns() {
      let columns = [...this.formulaMixRawColumns.supplement]
      if (this.filledSupplement) {
        columns[0].fixed = 'left'
      } else {
        delete columns[0].fixed
      }
      return columns
    }
  },
  mounted() {
    this.getList()
  },
  watch: {
    formula(item) {
      if (item.id) this.getList({ taskFormulaId: item.id })
    },
    resRaw(val) {
      if (val) this.getList()
    },
    showDiffOnly(val) {
      // 父组件更新 showDiffOnly 时（如切换分类取消勾选），重新过滤
      this.filterData(this.filterRawType, val)
    }
  },
  methods: {
    changeColumnsRation() {
      this.filledRation = !this.filledRation
    },
    changeColumnsSupplement() {
      this.filledSupplement = !this.filledSupplement
    },
    fixedColRation(e) {
      this.changeColumnsRation()
      e = e || window.event
      if (e.stopPropagation) {
        e.stopPropagation()
      } else {
        e.cancelBubble = true
      }
    },
    fixedColSupplement(e) {
      this.changeColumnsSupplement()
      e = e || window.event
      if (e.stopPropagation) {
        e.stopPropagation()
      } else {
        e.cancelBubble = true
      }
    },
    rowClassname(record) {
      let { uasge, isRawDelete, isDeleted, isExtraProRaw } = record || {}
      return isRawDelete == '1' || (isExtraProRaw == 1 && isDeleted == 1) ? 'selectGary' : (uasge == 0 ? 'selectRows' : '')
    },
    filterRaw(val) {
      // 兼容原有调用，仅按原料分类筛选
      this.filterRawType = val
      this.filterData(val, false)
    },
    // 勾选框变更事件：通知父组件同步状态
    onDiffOnlyCheckboxChange(e) {
      this.$emit('diff-only-change', e.target.checked)
    },
    // 统一过滤方法：支持原料分类 + 产品对比差异项
    filterData(rawType, showDiffOnly) {
      this.filterRawType = rawType
      let rationList = JSON.parse(JSON.stringify(this.cacheRationData));
      let supplementList = JSON.parse(JSON.stringify(this.cacheSupplementData));

      // 日粮：仅按原料分类筛选（无 productRawPercentage 列，不参与差异对比）
      if (rawType == 1) {
        rationList = rationList.filter(i => i.uasge > 0);
      } else if (rawType == 2) {
        rationList = rationList.filter(i => !i.uasge);
      }

      // 补充料：先按原料分类筛选
      if (rawType == 1) {
        supplementList = supplementList.filter(i => i.uasge > 0);
      } else if (rawType == 2) {
        supplementList = supplementList.filter(i => !i.uasge);
      }

      // 补充料：再按产品对比差异项筛选（基于页面显示值比较，显示精度 toFixed(4)）
      if (showDiffOnly) {
        supplementList = supplementList.filter(i => {
          const mixPer = (i.taskUasgePer != null && i.taskUasgePer !== '') ? Number(i.taskUasgePer).toFixed(4) : '';
          const productPer = (i.productRawPercentage != null && i.productRawPercentage !== '' && Number(i.productRawPercentage) != 0) ? Number(i.productRawPercentage).toFixed(4) : '';
          return mixPer !== productPer;
        });
      }

      this.rationList = rationList;
      this.supplementList = supplementList;
    },
    itemUpdate(item) {
      // 使用唯一标识来精确匹配和更新
      const targetRation = this.cacheRationData.find(i => i._uniqueId === item._uniqueId)
      const targetSupplement = this.cacheSupplementData.find(i => i._uniqueId === item._uniqueId)
      
      // 更新日粮
      if (targetRation) {
        Object.assign(targetRation, item)
        // 同步更新显示列表
        const displayRation = this.rationList.find(i => i._uniqueId === item._uniqueId)
        if (displayRation) {
          Object.assign(displayRation, item)
          this.$set(this, 'rationList', [...this.rationList])
        }
      }
      
      // 更新补充料
      if (targetSupplement) {
        Object.assign(targetSupplement, item)
        // 同步更新显示列表
        const displaySupplement = this.supplementList.find(i => i._uniqueId === item._uniqueId)
        if (displaySupplement) {
          Object.assign(displaySupplement, item)
          this.$set(this, 'supplementList', [...this.supplementList])
        }
      }
    },
    async update(data) {
      let { ...newData } = data || {}
      // 根据_uniqueId前缀判断是日粮还是补充料
      const isRation = data._uniqueId && data._uniqueId.startsWith('ration_')
      const action = isRation
        ? this.formulataskformularawSelfUpdate        // 日粮使用日粮接口
        : this.formulataskformularawUpdate   // 补充料使用原接口
      return this.fetchPost({
        showMessage: false,
        actions: action,
        data: newData,
      })
    },
    async getList(arg = {}) {
      // 日粮数据
      let rationRes = await this.fetchGet({
        actions: this.selectTaskFormulaSelfRawByTaskFormulaId,
        loading: "rawListLoading",
        data: {
          current: 1,
          size: 1000,
          taskFormulaId: this.formula.id,
          factoryId: this.factoryId,
          ...arg
        }
      })
      let { success: rationSuccess, data: rationData } = rationRes || {}
      if (rationSuccess && rationData && rationData.records) {
        // 为日粮数据添加唯一标识
        const rationRecords = rationData.records.filter(el => el.isDeleted != 1 || (el.isRawDelete == 1 || el.isExtraProRaw == 1))
        this.rationList = rationRecords.map((item, index) => ({
          ...item,
          _uniqueId: `ration_${item.rawId}_${index}` // 日粮唯一标识
        }))
        this.cacheRationData = JSON.parse(JSON.stringify(this.rationList))
      }

      // 补充料数据
      let supplementRes = await this.fetchGet({
        actions: this.selectTaskFormulaRawByTaskFormulaId,
        loading: "supplementListLoading",
        data: {
          current: 1,
          size: 1000,
          taskFormulaId: this.formula.id,
          factoryId: this.factoryId,
          ...arg
        }
      })
      let { success: supplementSuccess, data: supplementData } = supplementRes || {}
      if (supplementSuccess && supplementData && supplementData.records) {
        // 为补充料数据添加唯一标识
        const supplementRecords = supplementData.records.filter(el => el.isDeleted != 1 || (el.isRawDelete == 1 || el.isExtraProRaw == 1))
        this.supplementList = supplementRecords.map((item, index) => ({
          ...item,
          _uniqueId: `supplement_${item.rawId}_${index}` // 补充料唯一标识
        }))
        this.cacheSupplementData = JSON.parse(JSON.stringify(this.supplementList))
      }

      this.calculatePercentages()
      return { rationRes, supplementRes }
    },
    async calculatePercentages() {
      const res = await this.fetchGet({
        actions: this.selectTaskFormulaSelfRawRatioByTaskFormulaId,
        data: {
          taskFormulaId: this.formula.id
        }
      })
      if (res && res.success && res.data) {
        const selfProvidedProportion = res.data.selfProvidedProportion || 0
        this.rationPercentage = selfProvidedProportion
        this.supplementPercentage = 100 - selfProvidedProportion
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.formula-mix-raw {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  
  .table-section {
    display: flex;
    flex-direction: column;
    min-height: 0;
    margin-bottom: 8px;
    
    &.ration-section {
      flex: none;
    }

    &:last-child {
      flex: 1;
      margin-bottom: 0;
      overflow: hidden;

      ::v-deep .ant-table-wrapper,
      ::v-deep .ant-spin-nested-loading,
      ::v-deep .ant-spin-container,
      ::v-deep .ant-table {
        height: 100%;
      }
    }
    
    .section-header {
      display: flex;
      align-items: center;
      padding: 8px 10px;
      background: #f5f5f5;
      border-bottom: 1px solid #e8e8e8;
      
      .section-title {
        font-weight: bold;
        font-size: 14px;
        color: #333;
        margin-right: 12px;
      }
      
      .section-ratio {
        color: #1890ff;
        font-weight: 500;
        margin-right: 12px;
      }
      
      .section-constraint {
        color: #666;
        font-size: 12px;
      }
      
      .diff-checkbox {
        margin-left: auto;
      }
    }
  }
  
  ::v-deep .selectRows {
    background-color: rgba(255, 206, 163, 0.1) !important;
    background-color: #fff9e5 !important;
  }
  
  ::v-deep .selectGary {
    background-color: rgba(130, 130, 130, 0.1) !important;
  }
}
</style>
